import "./SkeletonResult.scss";

import React from "react";

interface SkeletonProps {
  classes?: string;
  img?: boolean;
  onClick?: () => void;
}
const SearchResultSkeleton: React.FC<SkeletonProps> = ({ classes, img }) => {
  return (
    <section>
      <div className="container">
        <div className="skel-cont">
          <div className="card-skeleton-img"></div>
          <div className="card-skeleton">
            <div className="animated-background">
              <div className="skel-mask-container">
                <div className="skel-mask skel-mask-1"></div>
                <div className="skel-mask skel-mask-2"></div>
                <div className="skel-mask skel-mask-3"></div>
                <div className="skel-mask skel-mask-4"></div>
                <div className="skel-mask skel-mask-6"></div>
              </div>
            </div>
          </div></div>
        <div className="skel-cont">
          <div className="card-skeleton-img"></div>
          <div className="card-skeleton">
            <div className="animated-background">
              <div className="skel-mask-container">
                <div className="skel-mask skel-mask-1"></div>
                <div className="skel-mask skel-mask-2"></div>
                <div className="skel-mask skel-mask-3"></div>
                <div className="skel-mask skel-mask-4"></div>
                <div className="skel-mask skel-mask-6"></div>
              </div>
            </div>
          </div></div>
      </div>
    </section>
  );
};

export default SearchResultSkeleton;
